export const createGameSendEventSlice = (props)=>()=>({
            gameSendEvent: {
                sendLeaveGame: props.sendLeaveGame,
                sendResignGame: props.sendResignGame,
                sendDisableKarma: props.sendDisableKarma,
                sendForceOpenGuideBubble: props.sendForceOpenGuideBubble,
                sendClickedPassTurn: props.sendClickedPassTurn,
                sendRequestSpecialBuildPhase: props.sendRequestSpecialBuildPhase,
                sendCancelSpecialBuildPhase: props.sendCancelSpecialBuildPhase,
                sendCancelAction: props.sendCancelAction,
                sendMoveShip: props.sendMoveShip,
                sendClearRoadEdgeHighlight: props.sendClearRoadEdgeHighlight,
                sendBuildShip: props.sendBuildShip,
                sendClearCornerHighlight: props.sendClearCornerHighlight,
                sendClearTileHighlight: props.sendClearTileHighlight,
                sendBuildSettlement: props.sendBuildSettlement,
                sendBuildRoad: props.sendBuildRoad,
                sendBuildCityWall: props.sendBuildCityWall,
                sendBuildCity: props.sendBuildCity,
                sendBuyDevCard: props.sendBuyDevCard,
                sendUpgradeKnight: props.sendUpgradeKnight,
                sendPlaceKnight: props.sendPlaceKnight,
                sendTakeKnightAction: props.sendTakeKnightAction,
                sendActivateKnight: props.sendActivateKnight,
                sendConfirmCityUpgrade: props.sendConfirmCityUpgrade,
                sendClickedDevelopmentCard: props.sendClickedDevelopmentCard,
                sendRequestActionSwap: props.sendRequestActionSwap,
                sendClickedDice: props.sendClickedDice,
                sendConfirmUseDevelopmentCard: props.sendConfirmUseDevelopmentCard,
                sendDiceNumberAnimationEnd: props.sendDiceNumberAnimationEnd,
                sendChatMessage: props.sendChatMessage
            }
        });
